export const wordCategories = {
  animals: {
    easy: [
      'cat', 'dog', 'fish', 'bird', 'cow', 'pig', 'duck', 'bear', 'lion', 'mouse',
      'frog', 'bee', 'ant', 'owl', 'fox', 'deer', 'goat', 'lamb', 'chick', 'bunny',
      'horse', 'sheep', 'hen', 'rooster', 'turkey', 'goose', 'rat', 'bat', 'seal',
      'whale', 'shark', 'crab', 'snail', 'worm', 'fly', 'moth', 'bug', 'snake',
      'turtle', 'lizard', 'toad', 'hawk', 'crow', 'dove', 'swan', 'robin', 'eagle',
      'wolf', 'elk', 'moose', 'pony', 'mule', 'donkey', 'camel', 'llama', 'yak'
    ],
    medium: [
      'elephant', 'giraffe', 'penguin', 'dolphin', 'tiger', 'zebra', 'monkey', 'kangaroo',
      'butterfly', 'spider', 'squirrel', 'hedgehog', 'raccoon', 'peacock', 'flamingo',
      'rhinoceros', 'hippopotamus', 'crocodile', 'octopus', 'jellyfish', 'leopard',
      'cheetah', 'jaguar', 'panther', 'lynx', 'bobcat', 'puma', 'cougar', 'hyena',
      'jackal', 'coyote', 'badger', 'otter', 'beaver', 'porcupine', 'skunk', 'opossum',
      'chipmunk', 'groundhog', 'marmot', 'prairie dog', 'ferret', 'weasel', 'mink',
      'mongoose', 'lemur', 'baboon', 'macaque', 'gibbon', 'gorilla', 'sloth', 'koala',
      'wombat', 'platypus', 'echidna', 'dingo', 'tasmanian devil'
    ],
    hard: [
      'chameleon', 'armadillo', 'platypus', 'narwhal', 'orangutan', 'chimpanzee',
      'wolverine', 'anteater', 'pangolin', 'wallaby', 'cassowary', 'axolotl',
      'chinchilla', 'fennec fox', 'quokka', 'tapir', 'capybara', 'aardvark',
      'mandrill', 'meerkat', 'binturong', 'kinkajou', 'coatimundi', 'olingo',
      'tayra', 'grison', 'jaguarundi', 'ocelot', 'margay', 'serval', 'caracal',
      'sand cat', 'pallas cat', 'fishing cat', 'clouded leopard', 'snow leopard',
      'sun bear', 'spectacled bear', 'sloth bear', 'honey badger', 'pine marten',
      'stone marten', 'fisher cat', 'genet', 'civet', 'fossa', 'tenrec', 'shrew',
      'vole', 'jerboa', 'chinchilla rat', 'viscacha', 'nutria', 'coypu', 'hutia',
      'agouti', 'paca', 'acouchy', 'degus', 'chinchilla mouse'
    ]
  },
  objects: {
    easy: [
      'car', 'house', 'tree', 'book', 'chair', 'table', 'door', 'window', 'phone', 'cup',
      'ball', 'toy', 'shoe', 'hat', 'bag', 'key', 'lamp', 'clock', 'pen', 'box',
      'bed', 'sofa', 'desk', 'shelf', 'mirror', 'brush', 'comb', 'towel', 'pillow',
      'blanket', 'plate', 'bowl', 'spoon', 'fork', 'knife', 'bottle', 'jar', 'can',
      'rope', 'chain', 'wheel', 'gear', 'nail', 'screw', 'wire', 'pipe', 'stick',
      'stone', 'brick', 'tile', 'glass', 'wood', 'metal', 'coin', 'ring', 'watch'
    ],
    medium: [
      'computer', 'bicycle', 'airplane', 'television', 'refrigerator', 'camera', 'guitar',
      'telescope', 'umbrella', 'suitcase', 'ladder', 'hammer', 'scissors', 'calculator',
      'microphone', 'toothbrush', 'flashlight', 'newspaper', 'envelope', 'mirror',
      'keyboard', 'monitor', 'printer', 'scanner', 'router', 'speaker', 'headphones',
      'battery', 'charger', 'cable', 'adapter', 'remote', 'controller', 'joystick',
      'telescope', 'binoculars', 'microscope', 'magnifier', 'thermometer', 'scale',
      'ruler', 'protractor', 'compass', 'stopwatch', 'timer', 'alarm', 'radio',
      'stereo', 'turntable', 'cassette', 'diskette', 'cartridge', 'memory card',
      'wrench', 'screwdriver', 'pliers', 'drill', 'saw', 'file', 'sandpaper'
    ],
    hard: [
      'microscope', 'stethoscope', 'thermometer', 'periscope', 'metronome', 'kaleidoscope',
      'barometer', 'compass', 'sextant', 'gramophone', 'typewriter', 'abacus',
      'hourglass', 'pendulum', 'prism', 'pulley', 'anvil', 'loom', 'kiln', 'lathe',
      'oscilloscope', 'spectrometer', 'chromatograph', 'centrifuge', 'incubator',
      'autoclave', 'calorimeter', 'photometer', 'hygrometer', 'anemometer',
      'seismograph', 'chronometer', 'astrolabe', 'theodolite', 'altimeter',
      'gyroscope', 'accelerometer', 'magnetometer', 'voltmeter', 'ohmmeter',
      'galvanometer', 'densitometer', 'refractometer', 'polarimeter', 'ellipsometer',
      'interferometer', 'radiometer', 'goniometer', 'spirometer', 'manometer',
      'tensiometer', 'viscometer', 'rheometer', 'turbidimeter', 'nephelometer'
    ]
  },
  actions: {
    easy: [
      'run', 'jump', 'walk', 'sit', 'eat', 'sleep', 'sing', 'dance', 'laugh', 'cry',
      'swim', 'fly', 'read', 'write', 'draw', 'play', 'hug', 'wave', 'clap', 'point',
      'stand', 'crawl', 'hop', 'skip', 'march', 'spin', 'roll', 'bend', 'stretch',
      'yawn', 'sneeze', 'cough', 'hiccup', 'blink', 'wink', 'smile', 'frown', 'nod',
      'shake', 'push', 'pull', 'lift', 'drop', 'throw', 'catch', 'kick', 'punch',
      'tickle', 'squeeze', 'pat', 'rub', 'scratch', 'brush', 'wash', 'dry', 'fold'
    ],
    medium: [
      'cooking', 'painting', 'gardening', 'jogging', 'climbing', 'driving', 'fishing',
      'knitting', 'typing', 'shopping', 'cleaning', 'building', 'teaching', 'studying',
      'exercising', 'traveling', 'camping', 'sailing', 'skiing', 'surfing',
      'swimming', 'diving', 'kayaking', 'hiking', 'cycling', 'running', 'sprinting',
      'weightlifting', 'stretching', 'practicing', 'rehearsing', 'performing',
      'composing', 'sketching', 'sculpting', 'carving', 'weaving', 'sewing',
      'embroidering', 'crocheting', 'quilting', 'woodworking', 'metalworking',
      'glassblowing', 'pottery', 'blacksmithing', 'welding', 'soldering', 'assembling',
      'disassembling', 'repairing', 'maintaining', 'inspecting', 'measuring', 'calculating'
    ],
    hard: [
      'procrastinating', 'meditating', 'choreographing', 'negotiating', 'investigating',
      'contemplating', 'improvising', 'demonstrating', 'orchestrating', 'synthesizing',
      'philosophizing', 'strategizing', 'troubleshooting', 'brainstorming', 'multitasking',
      'prioritizing', 'collaborating', 'communicating', 'facilitating', 'coordinating',
      'administrating', 'delegating', 'supervising', 'mentoring', 'counseling',
      'arbitrating', 'mediating', 'advocating', 'lobbying', 'campaigning',
      'fundraising', 'networking', 'recruiting', 'interviewing', 'evaluating',
      'analyzing', 'synthesizing', 'categorizing', 'systematizing', 'theorizing',
      'hypothesizing', 'experimenting', 'researching', 'documenting', 'archiving',
      'cataloguing', 'indexing', 'cross-referencing', 'fact-checking', 'proofreading',
      'copyediting', 'translating', 'interpreting', 'transcribing', 'summarizing'
    ]
  },
  food: {
    easy: [
      'apple', 'bread', 'milk', 'egg', 'cake', 'pizza', 'rice', 'soup', 'meat', 'fish',
      'banana', 'orange', 'grape', 'cookie', 'candy', 'ice cream', 'juice', 'water', 'tea', 'coffee',
      'cheese', 'butter', 'jam', 'honey', 'sugar', 'salt', 'pepper', 'oil', 'flour', 'corn',
      'beans', 'peas', 'carrots', 'onions', 'potato', 'tomato', 'lettuce', 'spinach',
      'broccoli', 'cauliflower', 'cucumber', 'peppers', 'mushrooms', 'garlic', 'ginger',
      'lemon', 'lime', 'peach', 'pear', 'plum', 'cherry', 'berries', 'melon', 'nuts', 'seeds'
    ],
    medium: [
      'sandwich', 'hamburger', 'spaghetti', 'salad', 'chicken', 'vegetables', 'cheese',
      'yogurt', 'cereal', 'pancake', 'waffle', 'muffin', 'donut', 'pretzel', 'popcorn',
      'chocolate', 'strawberry', 'pineapple', 'watermelon', 'avocado', 'burrito', 'tacos',
      'lasagna', 'ravioli', 'fettuccine', 'macaroni', 'linguine', 'penne', 'rigatoni',
      'cannelloni', 'tortellini', 'goulash', 'casserole', 'stir-fry', 'curry', 'chili',
      'stew', 'roast', 'barbecue', 'kebab', 'dumplings', 'wontons', 'spring rolls',
      'sushi', 'ramen', 'noodles', 'fried rice', 'pad thai', 'pho', 'bibimbap',
      'enchiladas', 'fajitas', 'nachos', 'guacamole', 'salsa', 'quiche', 'frittata'
    ],
    hard: [
      'bouillabaisse', 'ratatouille', 'quesadilla', 'bruschetta', 'gazpacho', 'risotto',
      'gnocchi', 'couscous', 'quinoa', 'edamame', 'tempura', 'sashimi', 'paella',
      'kimchi', 'hummus', 'tzatziki', 'borscht', 'charcuterie', 'soufflé', 'crème brûlée',
      'bouillabaisse', 'cacciatore', 'carbonara', 'puttanesca', 'arancini', 'osso buco',
      'saltimbocca', 'vitello tonnato', 'carpaccio', 'antipasto', 'prosciutto',
      'mortadella', 'pancetta', 'bresaola', 'coppa', 'capicola', 'sopressata',
      'nduja', 'guanciale', 'lardo', 'cotechino', 'bresaola', 'speck', 'culatello',
      'bourguignon', 'cassoulet', 'coq au vin', 'pot-au-feu', 'blanquette', 'fricassee',
      'confit', 'rillettes', 'pâté', 'terrine', 'foie gras', 'escargot', 'boudin',
      'choucroute', 'brandade', 'pistou', 'tapenade', 'aioli', 'rouille', 'persillade'
    ]
  },
  places: {
    easy: [
      'home', 'school', 'park', 'store', 'beach', 'zoo', 'farm', 'city', 'road', 'bridge',
      'hill', 'lake', 'river', 'mountain', 'forest', 'desert', 'island', 'garden', 'yard', 'field',
      'house', 'apartment', 'building', 'tower', 'barn', 'shed', 'garage', 'attic', 'basement',
      'kitchen', 'bedroom', 'bathroom', 'living room', 'dining room', 'hallway', 'stairs',
      'balcony', 'porch', 'deck', 'patio', 'driveway', 'sidewalk', 'street', 'avenue',
      'plaza', 'square', 'market', 'mall', 'shop', 'cafe', 'bank', 'post office', 'gym', 'pool'
    ],
    medium: [
      'hospital', 'library', 'museum', 'theater', 'restaurant', 'airport', 'station',
      'office', 'factory', 'university', 'cathedral', 'castle', 'palace', 'lighthouse',
      'waterfall', 'volcano', 'canyon', 'valley', 'meadow', 'swamp', 'courthouse',
      'embassy', 'consulate', 'auditorium', 'stadium', 'arena', 'colosseum', 'amphitheater',
      'gallery', 'workshop', 'laboratory', 'clinic', 'pharmacy', 'bakery', 'brewery',
      'winery', 'distillery', 'foundry', 'shipyard', 'hangar', 'warehouse', 'silo',
      'quarry', 'mine', 'refinery', 'mill', 'dam', 'reservoir', 'aqueduct', 'tunnel',
      'viaduct', 'causeway', 'boardwalk', 'promenade', 'marina', 'harbor', 'port', 'dock'
    ],
    hard: [
      'observatory', 'planetarium', 'conservatory', 'mausoleum', 'monastery', 'sanctuary',
      'archipelago', 'peninsula', 'fjord', 'glacier', 'tundra', 'savanna', 'prairie',
      'bayou', 'estuary', 'lagoon', 'cavern', 'crevasse', 'plateau', 'mesa',
      'escarpment', 'promontory', 'headland', 'cape', 'strait', 'channel', 'sound',
      'archipelago', 'atoll', 'reef', 'seamount', 'abyssal plain', 'continental shelf',
      'continental slope', 'mid-ocean ridge', 'oceanic trench', 'geyser', 'hot spring',
      'fumarole', 'caldera', 'cirque', 'moraine', 'drumlin', 'esker', 'kame',
      'arête', 'col', 'saddle', 'watershed', 'divide', 'confluence', 'meander',
      'oxbow lake', 'delta', 'alluvial fan', 'terrace', 'floodplain', 'badlands',
      'hoodoo', 'butte', 'inselberg', 'tor', 'scree', 'talus', 'cirque', 'corrie'
    ]
  },
  vehicles: {
    easy: [
      'car', 'bus', 'bike', 'truck', 'boat', 'plane', 'train', 'taxi', 'van', 'ship',
      'scooter', 'cart', 'sled', 'raft', 'kite', 'balloon', 'rocket', 'skateboard',
      'rollerskates', 'wheelchair', 'stroller', 'wagon', 'sleigh', 'canoe', 'kayak',
      'surfboard', 'snowboard', 'skis', 'tricycle', 'unicycle', 'motorcycle', 'moped',
      'jet', 'glider', 'parachute', 'hang glider', 'hot air balloon', 'ferry', 'yacht',
      'dinghy', 'speedboat', 'sailboat', 'rowboat', 'paddleboat', 'jetski', 'submarine',
      'helicopter', 'blimp', 'drone', 'go-kart', 'tractor',
      'ambulance', 'fire truck', 'police car'
    ],
    medium: [
      'limousine', 'convertible', 'pickup truck', 'semi-truck', 'trailer', 'bulldozer',
      'excavator', 'crane', 'forklift', 'steamroller', 'garbage truck', 'tow truck',
      'armored car', 'race car', 'sports car', 'hatchback', 'sedan', 'coupe', 'SUV',
      'minivan', 'station wagon', 'jeep', 'off-road vehicle', 'all-terrain vehicle',
      'snowcat', 'icebreaker', 'tugboat', 'barge', 'catamaran', 'trimaran', 'hovercraft',
      'hydrofoil', 'pontoon boat', 'fishing boat', 'cruise ship', 'cargo ship',
      'battleship', 'destroyer', 'frigate', 'aircraft carrier', 'coastguard cutter',
      'fighter jet', 'bomber', 'transport plane', 'cargo plane', 'seaplane', 'biplane',
      'glider plane', 'airship', 'space shuttle', 'lunar rover', 'quad bike', 'snowmobile',
      'tank', 'humvee', 'dune buggy', 'monster truck', 'rc car'
    ],
    hard: [
      'amphibious vehicle', 'articulated bus', 'double-decker bus', 'trolleybus',
      'funicular', 'cable car', 'monorail', 'maglev train', 'bullet train', 'steam locomotive',
      'freight train', 'passenger train', 'light rail', 'streetcar', 'tram',
      'backhoe loader', 'skid steer', 'wheel loader', 'dump truck',
      'concrete mixer', 'cherry picker', 'scissor lift', 'compactor',
      'asphalt paver', 'trencher', 'pile driver', 'drilling rig', 'mining truck',
      'logging truck', 'car carrier', 'tanker truck', 'refrigerated truck', 'mobile crane',
      'patrol boat', 'research vessel', 'oil tanker',
      'container ship', '747', '787 dreamliner', 'grave digger',
      'hydroplane', 'vertical takeoff aircraft', 'reconnaissance drone', 'stealth bomber',
      'firefighting aircraft',
      'orbital vehicle', 'interplanetary probe', 'space station', 'gyrocopter', 'RAM TRX'
    ]
  },
  books: {
    easy: [
      'book', 'page', 'word', 'letter', 'story', 'tale', 'hero', 'villain', 'magic', 'dragon',
      'princess', 'prince', 'witch', 'wizard', 'fairy', 'giant', 'monster', 'treasure',
      'adventure', 'journey', 'quest', 'friend', 'enemy', 'love', 'hate', 'happy', 'sad',
      'beginning', 'middle', 'end', 'chapter', 'title', 'author', 'reader', 'library',
      'bookmark', 'cover', 'picture', 'drawing', 'color', 'shape', 'number', 'alphabet',
      'rhyme', 'poem', 'song', 'riddle', 'puzzle', 'game', 'lesson', 'moral', 'fable',
      'legend', 'myth', 'folklore', 'bedtime', 'storytime'
    ],
    medium: [
      'novel', 'fiction', 'nonfiction', 'biography', 'autobiography', 'memoir', 'diary',
      'journal', 'encyclopedia', 'dictionary', 'thesaurus', 'atlas', 'almanac', 'textbook',
      'mystery', 'thriller', 'romance', 'fantasy', 'science fiction', 'horror', 'comedy',
      'drama', 'tragedy', 'protagonist', 'antagonist', 'character', 'plot', 'setting',
      'conflict', 'resolution', 'climax', 'dialogue', 'narration', 'perspective',
      'first person', 'third person', 'omniscient', 'prologue', 'epilogue', 'sequel',
      'prequel', 'trilogy', 'series', 'anthology', 'collection', 'volume', 'edition',
      'manuscript', 'draft', 'revision', 'editing', 'publishing', 'bestseller', 'classic',
      'literature', 'poetry', 'prose', 'verse', 'stanza', 'metaphor', 'simile',
      'magic tree house', 'harry potter', 'charlotte web'
    ],
    hard: [
      'allegory', 'alliteration', 'allusion', 'anachronism', 'anaphora', 'anthropomorphism',
      'antihero', 'apostrophe', 'archetype', 'assonance', 'bildungsroman', 'cacophony',
      'catharsis', 'chiasmus', 'colloquialism', 'denouement', 'deus ex machina', 'diction',
      'didactic', 'dystopian', 'epistolary', 'euphemism', 'exposition', 'foil',
      'foreshadowing', 'hamartia', 'hubris', 'hyperbole', 'iambic pentameter', 'imagery',
      'in medias res', 'irony', 'juxtaposition', 'leitmotif', 'litotes', 'malapropism',
      'metafiction', 'metonymy', 'motif', 'onomatopoeia', 'oxymoron', 'palindrome',
      'paradox', 'parallelism', 'parody', 'pastiche', 'pathos', 'personification',
      'picaresque', 'portmanteau', 'red herring', 'satire', 'soliloquy', 'stream of consciousness',
      'subplot', 'subtext', 'symbolism', 'synecdoche', 'syntax', 'theme', 'tone',
      'unreliable narrator', 'verisimilitude', 'vernacular', 'vignette', 'zeitgeist',
      'pride prejudice', 'mockingbird', 'great gatsby', 'romeo juliet',
      'Cat in the Hat', 'Harry Potter',
      'Diary of a Wimpy Kid', 'The Hunger Games', 'Percy Jackson', 'Matilda',
      'The BFG', 'James and the Giant Peach'
    ]
  },
  sports: {
    easy: [
      'ball', 'goal', 'win', 'lose', 'team', 'game', 'run', 'jump', 'catch', 'throw',
      'kick', 'hit', 'swim', 'bike', 'race', 'score', 'point', 'player', 'coach', 'referee',
      'field', 'court', 'pool', 'track', 'gym', 'net', 'bat', 'club', 'stick', 'puck',
      'helmet', 'uniform', 'jersey', 'medal', 'trophy', 'champion', 'fan', 'cheer',
      'timeout', 'halftime', 'whistle', 'flag', 'start', 'finish', 'fast', 'slow',
      'strong', 'weak', 'practice', 'match', 'contest', 'athlete', 'sport', 'exercise',
      'warmup', 'stretch'
    ],
    medium: [
      'basketball', 'football', 'soccer', 'baseball', 'tennis', 'volleyball', 'golf',
      'hockey', 'skiing', 'swimming', 'running', 'cycling', 'boxing', 'wrestling',
      'gymnastics', 'archery', 'bowling', 'skateboarding', 'surfing', 'snowboarding',
      'marathon', 'triathlon', 'Olympics', 'tournament', 'championship', 'playoffs',
      'stadium', 'arena', 'pitcher', 'catcher', 'quarterback', 'goalkeeper', 'striker',
      'defender', 'midfielder', 'forward', 'dribble', 'penalty', 'overtime', 'knockout',
      'submission', 'touchdown', 'homerun', 'birdie', 'eagle', 'strike', 'spare',
      'freestyle', 'backstroke', 'butterfly', 'breaststroke', 'hurdles', 'relay',
      'sprinter', 'marathon runner', 'weightlifting', 'powerlifting'
    ],
    hard: [
      'biathlon', 'pentathlon', 'decathlon', 'heptathlon', 'equestrian', 'fencing',
      'badminton', 'racquetball', 'squash', 'lacrosse', 'cricket', 'rugby', 'polo',
      'water polo', 'synchronized swimming', 'rhythmic gymnastics', 'figure skating',
      'speed skating', 'curling', 'bobsledding', 'luge', 'skeleton', 'cross-country skiing',
      'ski jumping', 'nordic combined', 'slalom', 'giant slalom', 'super-G', 'downhill',
      'moguls', 'halfpipe', 'slopestyle', 'parkour', 'ultimate frisbee', 'disc golf',
      'handball', 'jai alai', 'sepak takraw', 'kabaddi', 'pickleball', 'paddleball',
      'tetherball', 'dodgeball', 'kickball', 'stickball', 'hurling', 'shinty',
      'bandy', 'floorball', 'korfball', 'netball', 'gaelic football', 'australian rules',
      'sumo wrestling', 'judo', 'karate', 'taekwondo', 'aikido', 'kendo', 'muay thai',
      'capoeira', 'savate', 'sambo', 'krav maga'
    ]
  },
  history: {
    easy: [
      'king', 'queen', 'war', 'peace', 'sword', 'shield', 'castle', 'knight', 'crown', 'throne',
      'flag', 'map', 'ship', 'sailor', 'soldier', 'battle', 'victory', 'defeat', 'hero', 'leader',
      'ancient', 'old', 'past', 'year', 'century', 'empire', 'kingdom', 'country', 'nation',
      'people', 'tribe', 'village', 'town', 'city', 'wall', 'gate', 'tower', 'bridge', 'road',
      'gold', 'silver', 'treasure', 'coin', 'trade', 'merchant', 'explorer', 'discovery',
      'invention', 'book', 'scroll', 'writing', 'language', 'monument', 'statue', 'temple'
    ],
    medium: [
      'pyramid', 'colosseum', 'revolution', 'independence', 'democracy', 'monarchy',
      'republic', 'emperor', 'pharaoh', 'gladiator', 'samurai', 'viking', 'pirate',
      'crusade', 'medieval', 'renaissance', 'enlightenment', 'industrial', 'colonial',
      'explorer', 'conquistador', 'navigator', 'voyage', 'expedition', 'discovery',
      'archaeology', 'artifact', 'fossil', 'excavation', 'ruins', 'civilization',
      'dynasty', 'empire', 'conquest', 'invasion', 'siege', 'treaty', 'alliance',
      'rebellion', 'uprising', 'reform', 'abolition', 'suffrage', 'constitution',
      'declaration', 'proclamation', 'coronation', 'assassination', 'exile', 'restoration',
      'unification', 'partition', 'annexation', 'colonization', 'decolonization',
      'migration', 'immigration', 'emigration'
    ],
    hard: [
      'paleolithic', 'neolithic', 'mesopotamia', 'hieroglyphics', 'cuneiform', 'papyrus',
      'parchment', 'illuminated manuscript', 'magna carta', 'habeas corpus', 'feudalism',
      'manorialism', 'guild', 'apprenticeship', 'reformation', 'counter-reformation',
      'inquisition', 'excommunication', 'pilgrimage', 'crusader states', 'reconquista',
      'hundred years war', 'war of roses', 'thirty years war', 'napoleonic wars',
      'congress of vienna', 'balance of power', 'manifest destiny', 'monroe doctrine',
      'imperialism', 'sphere of influence', 'protectorate', 'mandate system',
      'appeasement', 'isolationism', 'containment', 'détente', 'perestroika', 'glasnost',
      'iron curtain', 'marshall plan', 'warsaw pact', 'non-aligned movement',
      'decolonization', 'partition of india', 'apartheid', 'civil rights movement',
      'suffragette', 'abolitionist', 'underground railroad', 'emancipation proclamation',
      'reconstruction', 'jim crow laws', 'new deal', 'great society', 'cold war',
      'space race', 'arms race', 'proxy war', 'domino theory', 'truman doctrine'
    ]
  },
};

export const getAllCategories = () => Object.keys(wordCategories);

export const getDifficulties = () => ['easy', 'medium', 'hard'];
